/** 官网图片在文件服务器上的根目录，和上传目录 hhytGw 一致 */
const FILE_BASE = 'https://file.ht-cargo-shipping.com//hhytGw/'

/** 按目录拼接图片地址，中文文件名逐段编码 */
export function fileUrl(path) {
  const parts = path.split('/').map(function (part) {
    return encodeURIComponent(part)
  })
  return FILE_BASE + parts.join('/')
}
